var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
const progressBarStyle = {
    borderRadius: '0px',
    boxShadow: 'unset',
    gridColumn: 'span 8',
    height: '8px',
    marginBottom: '20px',
    border: '1px solid #fff',
    width: '100px',
    color: '#ebebeb',
    display: 'flex'
};
const actualsBgColorStyle = {
    backgroundColor: '#637CEF',
    backgroundImage: 'none',
    marginRight: '1px',
    height: '100%'
};
const forecastedBgColorStyle = {
    backgroundColor: '#218721',
    backgroundImage: 'none',
    height: '100%'
};
const remainingBgColorStyle = {
    backgroundColor: '#ebebeb',
    backgroundImage: 'none',
    height: '100%'
};
const overbookedBgColorStyle = {
    backgroundColor: '#FF0000',
    backgroundImage: 'none',
    height: '100%'
};
export const styles = {
    progressBarStyle: progressBarStyle,
    actualsBgColorStyle: actualsBgColorStyle,
    forecastedBgColorStyle: forecastedBgColorStyle,
    remainingBgColorStyle: remainingBgColorStyle,
    overbookedBgColorStyle: overbookedBgColorStyle
};
//# sourceMappingURL=StackedBarComponent.styles.js.map